import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Reveal } from '@/components/landing/Reveal';

export const faqItems = [
  {
    q: 'What is Refify?',
    a: 'Refify is an interactive referencing system. You add your sources, and Refify formats every reference and in-text citation for you — ready to paste straight into your paper.',
  },
  {
    q: 'How fast is it to get started?',
    a: 'Very fast. Create a paper, pick a reference style, and add your first reference in under a minute. No setup, no installation — it runs in your browser.',
  },
  {
    q: 'Which citation styles are supported?',
    a: 'All of them. Styles in Refify are editable templates rather than a fixed list, so you can match APA, Harvard, or your own university guidelines exactly — down to each comma, full stop, and italic.',
  },
  {
    q: 'What if my university has its own referencing rules?',
    a: 'You can build a style that follows those rules exactly. Change any field, punctuation, or order in the template builder and every reference updates instantly — so your list always matches what your institution asks for.',
  },
  {
    q: 'Do I have to type in every detail myself?',
    a: 'No. Paste a link, DOI, ISBN, or a raw reference, and Quick Fill retrieves the details and maps them into the right fields. You just check and save.',
  },
  {
    q: 'Can I export to Word?',
    a: 'Yes. Export your reference list to Word (.docx), PDF, RTF, or plain text, or copy it as rich text and paste it directly into your document with formatting intact.',
  },
  {
    q: 'Can I organise references across several papers?',
    a: 'Yes. Each paper keeps its own reference list, and you can sort and group by source type, add private notes, and save favourites to reuse in future papers.',
  },
  {
    q: 'Can I work with others?',
    a: 'Yes. Invite collaborators to a paper as editor or viewer, so a team, study group, or supervisor can work on the same reference list.',
  },
  {
    q: 'Is there a free plan?',
    a: 'Yes. The Free plan covers a limited number of papers, references, and styles. Pro raises those limits, and universities can arrange access by contacting us.',
  },
  {
    q: 'Is my data private?',
    a: 'Yes. Everything you create is yours. We never sell or share your data, you can export your whole library at any time, and Refify is fully GDPR-compliant.',
  },
];

export function FaqSection() {
  return (
    <section id="faq" className="container mx-auto px-6 mt-24">
      <div className="max-w-3xl mx-auto">
        <Reveal variant="fade-up" duration={800}>
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center text-landing-green tracking-tight">
            Frequently asked questions
          </h2>
        </Reveal>
        <Reveal variant="fade-up" delay={120} duration={750}>
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`}>
                <AccordionTrigger className="text-left font-medium text-landing-ink">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-landing-ink/80 leading-relaxed">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
